import { APIErrorTranslations, HTTPErrorTranslations } from "translations/types";

/**
 * TODO_TRANSLATE_ES values mark copy added by the authentication work that needs
 * human translation before Spanish is enabled in production.
 */

const apiErrors: APIErrorTranslations = {
  ACCOUNT_ALREADY_EXISTS:
    "Ya existe una cuenta con esa dirección de correo electrónico.",
  ACTIONKIT_REQUEST_FAILED: "No se puede acceder a la base de datos de miembros.",
  BAD_REQUEST: "Solicitud fallida; Verifique su entrada y vuelva a intentarlo.",
  CREDENTIAL_NOT_FOUND: "TODO_TRANSLATE_ES",
  CURRENT_SESSION_NOT_FOUND: "TODO_TRANSLATE_ES",
  LAST_SECURE_SIGN_IN_METHOD: "TODO_TRANSLATE_ES",
  MALFORMED_PROFILE_PAYLOAD:
    "No se pudo actualizar el perfil; Verifique su entrada y vuelva a intentarlo.",
  MEMBER_NOT_IN_GOOD_STANDING:
    "No se puede verificar la membresía de DSA. Comuníquese con el personal para obtener ayuda.",
  NOT_LOGGED_IN:
    "El usuario no ha iniciado una sesión. Actualice la página y vuelva a intentarlo.",
  RATE_LIMIT_EXCEEDED: "Demasiadas solicitudes. Vuelve a intentarlo más tarde.",
  REQUEST_ENTITY_TOO_LARGE:
    "La carga es demasiado grande para que la maneje el servidor.",
  RESOURCE_NOT_FOUND: "No se pudo encontrar el recurso solicitado.",
  STRONG_AUTH_REQUIRED: "TODO_TRANSLATE_ES",
  TASK_ALREADY_COMPLETE: "La tarea ya falló o se completó y no se puede cancelar.",
  UNAUTHORIZED: "El usuario no tiene permiso para ver este recurso.",
  USER_NOT_IN_BETA_PROGRAM: "El usuario no puede acceder a myDSA en este momento.",
  USER_NOT_VERIFIED:
    "La cuenta no está verificada. Consulte su correo electrónico para obtener un enlace y comuníquese con el personal si necesita ayuda.",
  UNHANDLED_ERROR:
    "Algo inesperado salió mal. Por favor, inténtelo de nuevo más tarde.",
};

const httpErrors: HTTPErrorTranslations = {
  badRequest:
    "Hubo un error en tu solicitud. Verifique sus entradas y vuelva a intentarlo.",
  forbidden: "El usuario no está autorizado a acceder a este recurso.",
  notFound: "El servidor no pudo encontrar este recurso.",
  serverError: "Algo inesperado salió mal. Por favor, inténtelo de nuevo más tarde.",
  conflict: "El recurso ya existe.",
  preconditionFailed: "No se cumple la condición previa.",
  networkError:
    "No se puede llegar al servidor. Por favor, inténtelo de nuevo más tarde.",
  unauthorized: "El usuario no ha iniciado sesión.",
};

const es = {
  translation: {
    profileInfo: {
      account:
        "Actualice su nombre, correo electrónico y contraseña utilizando el siguiente formulario.",
      profile:
        "Actualice la información de su perfil de DSA mediante el formulario a continuación.",
    },
    disclaimer:
      "Verifico que esta es mi dirección de correo electrónico Y esta es la dirección de correo electrónico asociada con mi membresía de DSA.",
    createAccount: "Crea tu cuenta dsaID",
    hasAccount: "¿Ya tienes una cuenta? Registrarse",
    noAccount: "¿No tienes una cuenta? Regístrate",
    signIn: "Registrarse",
    //TODO: https://github.com/dsausa/mydsa/issues/317
    login: {
      redirecting: "Redirecting you to DSA sign in...",
      error: {
        title: "TODO_TRANSLATE_ES",
        body: "TODO_TRANSLATE_ES",
        action: "TODO_TRANSLATE_ES",
      },
    },
    signInText:
      "Utilice su cuenta dsaID para acceder a myDSA y otros servicios de DSA.",
    signUpText:
      "myDSA es un portal donde los miembros de DSA pueden ver y editar la información de su perfil. Para registrarse, debe ser un miembro activo.",
    signUp: "Regístrate",
    signupSuccess:
      "¡Cuenta creada! Revise su bandeja de entrada de correo electrónico para un correo electrónico de confirmación.",
    //TODO: https://github.com/dsausa/mydsa/issues/317
    signup: {
      actions: {
        continue: "Continue",
      },
      betaNotice:
        "MyDSA is currently in limited beta, available to select members in good standing.",
      emailHelp: "Use your DSA email address to continue.",
      emailPlaceholder: "you@example.com",
      page: {
        or: "Or",
        signInLink: "sign in to MyDSA",
        title: "Create your account",
      },
      success: {
        body: "TODO_TRANSLATE_ES",
        title: "TODO_TRANSLATE_ES",
      },
    },
    changeEmail:
      "Para actualizar su correo electrónico, haga clic en este enlace. Se le pedirá que ingrese y vuelva a verificar su nuevo correo electrónico.",
    changePassword:
      "Para actualizar su contraseña, haga clic en este enlace para enviar un correo electrónico de restablecimiento de contraseña.",
    //TODO: https://github.com/dsausa/mydsa/issues/317
    account: {
      settings: {
        title: "Email address",
      },
      signInMethods: {
        title: "TODO_TRANSLATE_ES",
        description: "TODO_TRANSLATE_ES",
        recommended: "TODO_TRANSLATE_ES",
        password: {
          add: "TODO_TRANSLATE_ES",
          change: "TODO_TRANSLATE_ES",
        },
        totp: {
          add: "TODO_TRANSLATE_ES",
          addAnother: "TODO_TRANSLATE_ES",
        },
        passkey: {
          title: "TODO_TRANSLATE_ES",
          description: "TODO_TRANSLATE_ES",
          add: "TODO_TRANSLATE_ES",
          addAnother: "TODO_TRANSLATE_ES",
        },
        strongFallback: {
          title: "TODO_TRANSLATE_ES",
          descriptionActive: "TODO_TRANSLATE_ES",
          descriptionMissingAuthenticator: "TODO_TRANSLATE_ES",
          descriptionMissingPassword: "TODO_TRANSLATE_ES",
          descriptionNotSetUp: "TODO_TRANSLATE_ES",
        },
        emailFallback: {
          title: "TODO_TRANSLATE_ES",
          addPassword: "TODO_TRANSLATE_ES",
          badgeAvailable: "TODO_TRANSLATE_ES",
          descriptionAvailable: "TODO_TRANSLATE_ES",
          descriptionNotSetUp: "TODO_TRANSLATE_ES",
        },
        status: {
          active: "TODO_TRANSLATE_ES",
          available: "TODO_TRANSLATE_ES",
          checking: "TODO_TRANSLATE_ES",
          finishSetup: "TODO_TRANSLATE_ES",
          notSetUp: "TODO_TRANSLATE_ES",
          unavailable: "TODO_TRANSLATE_ES",
        },
        unavailable: "TODO_TRANSLATE_ES",
        credentials: {
          password: "TODO_TRANSLATE_ES",
          totp: "TODO_TRANSLATE_ES",
          passkey: "TODO_TRANSLATE_ES",
          added: "TODO_TRANSLATE_ES {{label}} {{date}}",
          remove: "TODO_TRANSLATE_ES {{label}}",
          removeAction: "TODO_TRANSLATE_ES",
          removeUnavailable: "TODO_TRANSLATE_ES",
        },
        removal: {
          cancel: "TODO_TRANSLATE_ES",
          confirm: "TODO_TRANSLATE_ES",
          description: "TODO_TRANSLATE_ES {{credential}}",
          error: "TODO_TRANSLATE_ES",
          reauthenticate: "TODO_TRANSLATE_ES",
          signInAgain: "TODO_TRANSLATE_ES",
          success: "TODO_TRANSLATE_ES {{credential}}",
          title: "TODO_TRANSLATE_ES",
        },
      },
      recoveryComplete: {
        title: "TODO_TRANSLATE_ES",
        description: "TODO_TRANSLATE_ES",
      },
      changeEmail: "Change email",
      changePassword: "Change password",
      setupTotp: "Configurar una aplicación de autenticación",
      setupPasskey: "Configurar una clave de acceso o llave de seguridad",
      email: "Email",
      form: {
        title: "Profile information",
      },
      mailingAddress: "Mailing address",
      mailingPreferences: "Mailing preferences",
      name: "Member name",
      password: "Password",
      phone: "Phone",
      save: "Save profile",
    },
    signOut: "Desconectar",
    loading: "Cargando",
    save: "Ahorrar",
    update: "Update",
    //TODO: https://github.com/dsausa/mydsa/issues/317
    dashboard: {
      actions: {
        update: "Update",
      },
      loading: {
        card: "Loading card",
        welcomeCard: "Loading welcome card",
      },
      unavailable: "Not yet available",
      welcome: {
        greeting: "Welcome back,",
        chapter: "Chapter: {{chapter}}",
        localChapter: "Local chapter",
        chapterTooltip:
          "Need to change your chapter? Update your mailing address in Profile.",
        profilePhotoAlt: "{{name}} profile photo",
      },
      membership: {
        title: "Billing",
        billingName: "Billing name",
        billingAddress: "Billing address",
        memberSinceLabel: "Member since",
        memberSince: "Member since {{date}}",
        duesBannerPrefix: "Visit",
        duesBannerSuffix: "to modify your dues.",
        dues: "Dues",
        cardExpiration: "Card expiration",
        paymentMethod: "Payment method",
        nextPayment: "Next payment",
        actions: {
          renew: "Renew membership",
          sendProof: "Send proof of membership",
          viewDetails: "View Details",
        },
        status: {
          goodStanding: "Member in Good Standing",
          former: "Former member",
          lapsed: "Lapsed",
          merged: "Merged account",
          unknown: "Unknown",
        },
      },
      personalInformation: {
        title: "Member profile",
        name: "Name",
        email: "Email",
        phone: "Phone",
        mailingAddress: "Mailing address",
        missingValue: "Not provided",
      },
      preferences: {
        title: "Preferences",
        mailingPreference: {
          physicalMail: "Send physical mail",
          noPhysicalMail: "Do not send physical mail",
          membershipCardOnly: "Send membership card only",
        },
        magazinePreference: {
          sendDemocraticLeft: "Send Democratic Left",
          noDemocraticLeft: "Do not send Democratic Left",
        },
      },
      profile: {
        title: "Profile",
        description:
          "Help us better understand the multiracial working class by updating your profile questions.",
      },
    },
    forms: {
      required: "obligatorio",
      profile: {
        primarySection: "Facturación",
        mailingSection: "Información Postal",
        demographicsSection: "Información demográfica",
        basic: {
          title: "Información básica",
          description:
            "Actualice su nombre preferido, dirección de correo electrónico y otra información de perfil.",
        },
        primaryAddress: {
          title: "Dirección de facturación",
          description: "Actualice su información de contacto de facturación.",
        },
        mailingAddress: {
          title: "Dirección de envio",
          description:
            "Actualice su dirección postal. Esta dirección se utilizará para todo el correo físico, como su tarjeta de membresía y copias de Democratic Left.",
        },
        union: {
          title: "Información sindical",
          description: "Actualice el nombre de su sindicato y la rama local.",
        },
      },
      // TODO: https://github.com/dsausa/mydsa/issues/317
      account: {
        firstName: "First name",
        lastName: "Last name",
        updateName: {
          title: "Update Name",
          profileBanner:
            "Visit <1>your profile</1> to edit your pronouns and other information.",
        },
        updateEmail: {
          title: "Update Email Address",
          faqBanner:
            "Visit <1>https://www.dsausa.org/resources/faq/</1> to change your email address.",
        },
      },
      //TODO: https://github.com/dsausa/mydsa/issues/317
      preferences: {
        mailingSection: "Mailing",
        mailingAddress: {
          title: "Mailing address",
          banner:
            "Your mailing address is used to determine your affiliated chapter. Changing your mailing address will change your chapter affiliation within 24 hours.\n\nIf you would like to request an At-Large membership, or otherwise override your chapter assignment, you can request that <1>here</1>.",
        },
      },
      disabled: {
        email: "La dirección de correo electrónico no se puede editar en este momento.",
      },
      labels: {
        email: "Dirección de correo electrónico",
        firstName: "Nombre de pila",
        lastName: "Apellido",
        chosenFirstName: "Nombre elegido",
        chosenLastName: "Apellido elegido",
        password: "Contraseña",
        passwordConfirmation: "Confirmación de contraseña",
        mailingPreference: {
          title: "Preferencias de correo",
          description: "¿Le gustaría recibir correo físico de DSA?",
          option0: "Correo",
          option1: "Solo digital",
          option2: "Envíe solo mi tarjeta de membresía",
        },
        dlMailingPreference: {
          title: "Preferencias de correo de la izquierda democrática",
          option0: "Correo",
          description:
            "¿Le gustaría recibir copias de Democratic Left, la revista miembro de la DSA, por correo?",
          option1: "Solo digital",
        },
        unionMember: {
          title: "Miembro del sindicato",
          description: "¿Es miembro de un sindicato?",
          option0: "No",
          option1: "Sí",
          option2: "Ex miembro del sindicato",
          option3: "Miembro del sindicato jubilado",
        },
        unionLeadership: {
          title: "Liderazgo sindical",
          description: "¿Está en el liderazgo de su sindicato?",
          option0: "No",
          option1: "Sí",
        },
        gender: {
          title: "Preferencia de Género",
          description: "¿Cuál es su preferencia de género?",
          tooltip:
            "DSA recopila esta información para ayudar a comprender la composición de nuestra organización y determinar en qué comunidades necesitamos hacer más esfuerzos organizativos.",
          option0: "Hombre",
          option1: "Mujer",
          option2: "No binario",
          option3: "No conforme al género",
          option4: "Otro (o no especificado)",
        },
        lgbtq: {
          title: "LGBTQ+",
          description: "¿Te identificas como LGBTQ+?",
          tooltip:
            "DSA recopila esta información para ayudar a comprender la composición de nuestra organización y determinar en qué comunidades necesitamos hacer más esfuerzos organizativos.",
          option0: "No",
          option1: "Sí",
        },
        unionName: "Nombre de la unión",
        unionLocal: "Unión local",
        primaryLine1: "Dirección Línea 1",
        primaryLine2: "Línea de dirección 2",
        primaryCity: "Ciudad",
        primaryZip: "Código postal",
        primaryState: "Expresar",
        primaryCountry: "País",
        mailingLine1: "Dirección Línea 1",
        mailingLine2: "Línea de dirección 2",
        mailingCity: "Ciudad",
        mailingZip: "Código postal",
        mailingState: "Expresar",
        mailingCountry: "País",
      },
      placeholders: {
        email: "Ingrese su dirección de correo electrónico",
        firstName: "Ponga su primer nombre",
        lastName: "Ingrese su apellido",
        chosenFirstName: "Ingrese su nombre preferido",
        chosenLastName: "Ingrese su apellido preferido",
        //TODO: https://github.com/dsausa/mydsa/issues/317
        phone: "Enter your phone number",
        password: "Elije una contraseña",
        passwordConfirmation: "Vuelva a escribir su contraseña",
        primaryLine1: "Ingrese su dirección postal",
        primaryLine2: "Ingrese su dirección postal",
        primaryCity: "Ingresa tu ciudad",
        primaryZip: "Ingrese su codigo postal",
        primaryState: "Selecciona un Estado",
        primaryCountry: "Seleccione un país",
        mailingLine1: "Ingrese su dirección postal",
        mailingLine2: "Ingrese su dirección postal",
        mailingCity: "Ingresa tu ciudad",
        mailingZip: "Ingrese su codigo postal",
        mailingState: "Ingrese su estado",
        mailingCountry: "Ingrese su pais",
        unionName: "Ingrese el nombre de su sindicato",
        unionLocal: "Ingrese su sindicato local",
      },
    },
    countries: {
      US: {
        states: {
          AL: { displayName: "Alabama (AL)" },
          AK: { displayName: "Alaska (AK)" },
          AZ: { displayName: "Arizona (AZ)" },
          AR: { displayName: "Arkansas (AR)" },
          CA: { displayName: "California (CA" },
          CO: { displayName: "Colorado (CO)" },
          CT: { displayName: "Connecticut (CT)" },
          DE: { displayName: "Delaware (DE)" },
          DC: { displayName: "Distrito de Columbia (DC)" },
          FL: { displayName: "Florida (FL)" },
          GA: { displayName: "Georgia (GA)" },
          HI: { displayName: "Hawái (HI)" },
          ID: { displayName: "Idaho (ID)" },
          IL: { displayName: "Illinois (IL)" },
          IN: { displayName: "Indiana (IN)" },
          IA: { displayName: "Iowa (IA)" },
          KS: { displayName: "Kansas (KS)" },
          KY: { displayName: "Kentucky (KY)" },
          LA: { displayName: "Luisiana (LA)" },
          ME: { displayName: "Maine (ME)" },
          MD: { displayName: "Maryland (MD)" },
          MA: { displayName: "Massachusetts (MA)" },
          MI: { displayName: "Michigan (MI)" },
          MN: { displayName: "Minnesota (MN)" },
          MS: { displayName: "Mississippi (MS)" },
          MO: { displayName: "Missouri (MO)" },
          MT: { displayName: "Montana (MT)" },
          NE: { displayName: "Nebraska (NE)" },
          NV: { displayName: "Nevada (NV)" },
          NH: { displayName: "Nuevo Hampshire (NH)" },
          NJ: { displayName: "Nueva Jersey (NJ)" },
          NM: { displayName: "Nuevo México (NM)" },
          NY: { displayName: "Nueva York (NY)" },
          NC: { displayName: "Carolina del Norte (NC)" },
          ND: { displayName: "Dakota del Norte (ND)" },
          OH: { displayName: "Ohio (OH)" },
          OK: { displayName: "Oklahoma (OK)" },
          OR: { displayName: "Oregón (OR)" },
          PA: { displayName: "Pensilvania (PA)" },
          RI: { displayName: "Rhode Island (RI)" },
          SC: { displayName: "Carolina del Sur (SC)" },
          SD: { displayName: "Dakota del Sur (SD" },
          TN: { displayName: "Tennessee (TN)" },
          TX: { displayName: "Texas (TX)" },
          UT: { displayName: "Utah (UT)" },
          VT: { displayName: "Vermont (VT)" },
          VA: { displayName: "Virginia (VA)" },
          WA: { displayName: "Washington (WA)" },
          WV: { displayName: "Virginia del Oeste (WV)" },
          WI: { displayName: "Wisconsin (WI)" },
          WY: { displayName: "Wyoming (WY)" },
          AS: { displayName: "Samoa Americana (AS)" },
          GU: { displayName: "Guam (GU)" },
          MP: { displayName: "Islas Marianas del Norte (MP)" },
          PR: { displayName: "Puerto Rico (PR)" },
          UM: { displayName: "United States Minor Outlying Islands (UM)" },
          VI: { displayName: "Islas Vírgenes (VI)" },
          AA: { displayName: "Fuerzas Armadas Américas (AA)" },
          AP: { displayName: "Fuerzas Armadas del Pacífico (AP)" },
          AE: { displayName: "Fuerzas Armadas (AE)" },
        },
      },
    },
    errors: {
      fallback: "TRANSLATE: Something went wrong! Please try again later.",
      profileIneligible:
        "Su perfíl no está eligible para este servicio. Para mas informacion ve la pagina de <1>Preguntas Frecuentes</1>.",
      forms: {
        input: "{{ value }} es obligatorio",
        memberFirstName: "Member first name is required",
        memberLastName: "Member last name is required",
        checkbox: "Debe verificar para continuar",
        email: {
          missing: "Correo electronico es requerido",
          invalid: "Dirección de correo electrónico inválida",
        },
        password: {
          missing: "Se requiere contraseña",
          missingConfirmation: "Se requiere confirmación de contraseña",
          mismatch: "Las contraseñas no coinciden",
          length: "La contraseña debe tener al menos {{ count }} caracteres",
        },
        primaryZip: {
          invalid: "Enter a 5-digit ZIP code or ZIP+4 (e.g. 02139-1234).",
        },
        mailingZip: {
          invalid: "Enter a 5-digit ZIP code or ZIP+4 (e.g. 02139-1234).",
        },
      },
      server: {
        api: apiErrors,
        http: httpErrors,
      },
    },
    messages: {
      profile: {
        success: "¡Perfil actualizado!",
      },
      passwordReset: {
        success:
          "Correo electrónico de restablecimiento de contraseña enviado a {{ email }}!",
      },
      mergedAccount: {
        default:
          "This account has been merged with another membership account. Please use the primary membership account to sign in.",
        withEmail:
          "This account has been merged with another membership account. Please log in using this email address: {{email}}.",
      },
      signup: {
        success:
          "¡Cuenta creada! Consulte la bandeja de entrada de {{ email }} para obtener un enlace para confirmar su cuenta.",
      },
      memberDetails: {
        formerMember:
          "Su membresía expiró. Para obtener más información o volver a unirse, consulte las <1>preguntas frecuentes</1>.",
        lapsedMember:
          "Está atrasado en las cuotas. Para obtener más información, consulte las <1>preguntas frecuentes</1>.",
        member: "Usted es un miembro activo.",
        nonMemberFallback: "Su estatus de membresía no está disponible.",
        joinDate: "Fecha de ingreso",
        verifiedEmail: "Su dirección de correo electrónico verificada",
      },
      memberStatusError: {
        lapsedMember:
          "Está atrasado en las cuotas. Para obtener más información, consulte las preguntas frecuentes.",
        formerMember:
          "Su membresía expiró. Para obtener más información o volver a unirse, consulte las preguntas frecuentes.",
      },
    },
    nav: {
      home: "Hogar",
      account: "Cuenta",
      profile: "Member profile",
      faq: "Preguntas Frecuentes",
    },
    pages: {
      home: "Bienvenido a myDSA",
      //TODO: https://github.com/dsausa/mydsa/issues/317
      account: "Member profile",
      //TODO: https://github.com/dsausa/mydsa/issues/317
      membership: "Billing",
      backToHome: "Back to home",
      //TODO: https://github.com/dsausa/mydsa/issues/317
      preferences: "Mailing Preferences",
      profile: "Member profile",
      login: "Inicie sesión con su dsaID",
      error: "¡Uy! Nos encontramos con un error.",
      faq: "Preguntas frecuentes",
    },
    //TODO: https://github.com/dsausa/mydsa/issues/317
    membershipPage: {
      billingName: "Billing name",
      billingAddress: "Billing address",
      comingSoon:
        "Coming soon: managing your dues directly from myDSA! In the meantime, please fill out the forms linked below to complete your requests.",
      donation: "Donation",
      dues: "Dues",
      cardExpiration: "Card expiration",
      nextPaymentDate: "Next payment date",
      paymentMethod: "Payment method",
      paymentHistory: "Payment history",
      unavailable: "Coming soon",
      noPaymentHistory: "No payments made in the last year.",
      actions: {
        title: "Membership actions",
        updateDues: "Update dues or payment method",
        requestWaiver: "Request a dues waiver",
        cancelDues: "Cancel dues payments",
        requestRefund: "Request a refund",
        requestMembershipCard: "Request a new membership card",
      },
      modal: {
        close: "Close",
        title: "Cancelling due to financial hardship?",
        body: "You can continue to be a member of DSA by requesting a dues waiver for one year.",
        cancelMembership: "Cancel my membership",
        requestWaiver: "Request a dues waiver",
      },
    },
    header: {
      menu: "Account menu",
      menuButton: "Open account menu",
      menuLabel: "Menu",
      menuItems: {
        account: "Member profile",
        home: "Home",
        membership: "Billing",
      },
      title: "myDSA",
    },
    footer: {
      support: "Soporte",
      languages: {
        en: "English",
        es: "Español",
      },
    },
    icons: {
      book: "Libro",
      caret: "No es",
      checkbox: "Caja",
      gift: "Regalo",
      globe: "Globo",
      lightbulb: "Bombilla",
      menu: "Menú",
      phone: "Teléfono",
      star: "Estrella",
      user: "Usuario",
      warning: "Advertencia",
    },
  },
} as const;

export default es;
